document.addEventListener('DOMContentLoaded', () => {
    const tabs = $('.js-types-tabs');
    const panes = $('.js-types-panes');

    tabs && tabs.slick({
        dots: false,
        arrows: false,
        slidesToShow: 4,
        focusOnSelect: true,
        rtl: m.about.rtl,
        asNavFor: '.js-types-panes'
    });

    panes && panes.slick({
        dots: false,
        arrows: false,
        fade: true,
        slidesToShow: 1,
        draggable: false,
        swipe: false,
        rtl: m.about.rtl,
        asNavFor: '.js-types-tabs',
    });
});
